function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { TOUR_DONE_MODAL } from '../../../../../components/modal/TourDoneModal';
import { showModal } from '../../../../../redux/actions';
import { store } from '../../../../../utilities/store';
import { StepContent } from './TourContent';
import { hightlightedAreaStyling, popoverCustomDefaultStyling } from './config';
import text from '../../../../../text';
export var TOUR_3D_VIEWER = [
    {
        selector: '.p__sidebar-list',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour3dViewerStep1Title'),
                description: text('tour3dViewerStep1')
            });
        },
        position: 'right',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '24px',
                    top: '-34px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left'
        }
    },
    {
        selector: '.button-list li:nth-child(2)',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour3dViewerStep2Title'),
                description: text('tour3dViewerStep2'),
                externalLinkHelp: 'https://help.pointerra.io/articles/30882-using-the-cropping-tools'
            });
        },
        position: 'right',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '16px',
                    top: '-62px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left'
        }
    },
    {
        selector: '.button-list li:nth-child(3)',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour3dViewerStep3Title'),
                description: text('tour3dViewerStep3'),
                externalLinkHelp: 'https://help.pointerra.io/articles/40390-cropping-points-with-the-vertical-cropping-tool'
            });
        },
        position: 'right',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '16px',
                    top: '-72px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left'
        }
    },
    {
        selector: '.button-list li:nth-child(4)',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour3dViewerStep4Title'),
                description: text('tour3dViewerStep4'),
                externalLinkHelp: 'https://help.pointerra.io/articles/40391-using-the-cross-section-tool'
            });
        },
        position: 'right',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '16px',
                    top: '-62px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left'
        }
    },
    {
        selector: '.button-list li:nth-child(5)',
        content: function() {
            return /*#__PURE__*/ React.createElement(StepContent, {
                title: text('tour3dViewerStep5Title'),
                description: ''
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-3"
            }, text('tour3dViewerStep5_1')), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, text('tour3dViewerStep5_2')), "(", /*#__PURE__*/ React.createElement("a", {
                href: "https://help.pointerra.io/articles/40139-using-the-distance-measurement-tool",
                target: "_blank",
                rel: "noopener noreferrer"
            }, text('learnMore')), ")");
        },
        position: 'right',
        styles: {
            popover: function(base) {
                return _object_spread_props(_object_spread({}, popoverCustomDefaultStyling(base)), {
                    marginLeft: '16px',
                    top: '-100px'
                });
            },
            highlightedArea: function(base, state) {
                return hightlightedAreaStyling(base, state);
            }
        },
        customProps: {
            caret: 'left',
            callback: {
                next: function() {
                    store.dispatch(showModal(TOUR_DONE_MODAL));
                }
            }
        }
    }
];
